/** @jsx jsx */
import { Link } from 'gatsby'
import { Flex, jsx, Text } from 'theme-ui'
import Logo from '~/assets/images/logos/maker-wine-logo.inline.svg'
import VisuallyHidden from '~/components/Generic/VisuallyHidden'

const NavMenuLogo = ({ isTrade }) => {
  return (
    <Link
      to={!isTrade ? '/' : '/trade/'}
      sx={{
        borderRadius: '4px',
        flexShrink: 0,
        mx: '-8px',
        pt: ['3px', '2px'],
        px: '8px',
        textDecoration: 'none',
        '& svg': { height: 'auto', width: '140px' },
      }}
    >
      <Flex sx={{ alignItems: 'center' }}>
        <Logo />
        {!isTrade && (
          <VisuallyHidden>
            <Text as="p">{'Home'}</Text>
          </VisuallyHidden>
        )}
        {isTrade && (
          <Text
            ml={2}
            sx={{
              color: 'greyDark',
              fontSize: ['18px', '20px'],
              letterSpacing: '3px',
              lineHeight: '20px',
              textTransform: 'uppercase',
            }}
          >
            {'Trade'}
          </Text>
        )}
      </Flex>
    </Link>
  )
}

export default NavMenuLogo
